import * as React from 'react'

import request from '@/server/request';
import config from '@/server/config';

export default class Supplementary extends React.Component < any, any > {
    constructor(props: any) {
        super(props)
        this.state = {
        	info: {}
        }
    }

    public componentDidMount() {
    	this.getData()
    }

    public render() {
    	const { info } = this.state
        return (
            <section>
				<div className="banner clear"><img src={require('@/assets/images/img1.jpg')} alt="" /></div>
				<div className="form">
			    <p className="success title">恭喜您，请凭此内容领取产业研报。</p>
			    <br />
			    <p className="success">姓名：{info.name}</p>
			    <p className="success">公司：{info.companyName}</p>
			    <p className="success">手机：{info.phone}</p>
			    <p className="success">并且恭喜您获得《2022涂料产业研究报告》一本，您可凭借此页面，展会期间前往“慧正资讯&amp;买化塑”展位，免费领取。</p>
			    <p>领取地址的展位号码：2.1F31</p>
			    <p className="success">免费领取时间：</p>
			    <p className="success">2月22日（周三） 09:00 – 17:00<br />
			      2月23日（周四） 09:00 – 17:00<br />
			      2月24日（周五） 09:00 – 13:00</p>
			    <br />
			    <p className="success">中国国际涂料展地址：</p>
			    <p className="success">中国进出口商品交易会展馆（广交会展馆）A区（中国广州市海珠区阅江中路380号）</p>
			    <div className="time">
			      <b>开放时间*：</b>
			      <p>2月22日（周三） 09:00 – 17:00<br />
			        2月23日（周四） 09:00 – 17:00<br />
			        2月24日（周五） 09:00 – 13:00</p>
			    </div>
			    <p className="red">* 每天展期闭馆前30分钟谢绝观众进场。主办单位保留更改开放时间之权利。</p>
			  </div>
			  <img src={require('@/assets/images/img2.png')} alt="" className="img" />
			</section>
        )
    }

    // 获取数据
    private getData() {
    	request({
	        method: "get",
	        url: `${config.API2}ex/register/info`,
	      }).then(r=> {
	        if (r.code === 1) {
	          this.setState({
	            info: r.obj
	          })
	        }
	      })
    }
}